import { TrackingDetailScreen } from '@mrrmlab/feature-tracking';

export function PaketeDetailRoute({ trackingId }: { trackingId: string }) {
  return <TrackingDetailScreen trackingId={trackingId} />;
}
